import Backbone from 'backbone';

export default Backbone.Model.extend({
  url: function() {
    var url = Backbone.history.options.root + this.id + ".json";
    return url;
  }
});
